export default "__VITE_PUBLIC_ASSET__65b4e60b__"